import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { IKeywordListItem, KeywordListItem } from "./keywordListItem";

export interface IKeywordListItems extends IListItems<IKeywordListItem> {}

export class KeywordListItems extends ListItems<KeywordListItem> implements IKeywordListItems {
    constructor();
    constructor(obj: IKeywordListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, KeywordListItem);
    }
}